export const ExceptionDayType = {
  Office: 'Office',
  Operator: 'Operator'
}
